/**
 * @description 导出自定义配置
 **/
const config = {
  layout: 'vertical',
  templateFolder: 'project',
}
module.exports = config
